import { useLanguage } from '@/contexts';
import { FC } from 'react';
import FeatureCard from '../FeatureCard';
import TeamsWaitlistForm from '../TeamWaitlistForm';

const TeamsWaitlistPage: FC = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-900 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-slate-100 transition-colors duration-200">{t('promptShelfTeams')}</h1>
          <p className="text-xl text-gray-600 dark:text-slate-300 max-w-3xl mx-auto transition-colors duration-200">{t('promptShelfTeamsDescription')}</p>
        </div>
      </div>
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-lg p-8 my-4 flex flex-col items-center text-center max-w-5xl mx-auto gap-14 transition-colors duration-300">
        <div className="flex flex-col md:flex-row justify-around gap-8">
          <FeatureCard
            title={t('collaborate')}
            subtitle={t('promptShelfTeamsCards.workTogether')}
            SVGIcon={() => (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" className="size-12">
                <circle cx="8" cy="7" r="3" />
                <circle cx="16" cy="7" r="3" />
                <path d="M2 20c0-3.5 3-6 6-6s6 2.5 6 6H2Zm8 0c0-3.5 3-6 6-6s6 2.5 6 6h-12Z" />
              </svg>

            )}
          />
          <FeatureCard
            title={t('govern')}
            subtitle={t('promptShelfTeamsCards.setPolicies')}
            SVGIcon={() => (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" className="size-12">
                <circle cx="12" cy="12" r="9" />
                <polygon points="10 14 13 13 14 10 11 11" />
              </svg>
            )}
          />
          <FeatureCard
            title={t('measure')}
            subtitle={t('promptShelfTeamsCards.trackMeasure')}
            SVGIcon={() => (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" className="size-12">
                <rect x="4" y="12" width="3" height="8" />
                <rect x="10" y="9" width="3" height="11" />
                <rect x="16" y="5" width="3" height="15" />
              </svg>

            )}
          />
          <FeatureCard
            title={t('secure')}
            subtitle={t('promptShelfTeamsCards.enterpriseSecurity')}
            SVGIcon={() => (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5" className="size-12">
                <rect x="5" y="11" width="14" height="10" rx="2" />
                <path d="M8 11V7a4 4 0 1 1 8 0v4" />
              </svg>

            )}
          />
        </div>

        <div className="gap-12">
          <h3 className="text-xl font-bold mb-4 text-gray-900 dark:text-slate-100 transition-colors duration-200">{t('promptShelfTeamsSignUp')}</h3>
          <p className="text-gray-600 dark:text-slate-300 transition-colors duration-200">{t('promptShelfTeamsNotify')}</p>
          <div className="max-w-xl mx-auto overflow-hidden">
            <div className="p-10">
              <TeamsWaitlistForm />
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mt-16 mb-4 text-sm text-gray-500 dark:text-slate-400 transition-colors duration-200">
        <p>© {new Date().getFullYear()} PromptShelf. {t('allRightsReserved')}.</p>
      </div>
    </div>
  );
};

export default TeamsWaitlistPage;
